import React from "react";
import {Tooltip as ReactTooltip} from "react-tooltip";
import styled from "styled-components";
import {QuestionMarkIcon} from "ui/icons";
import {defaultThemeColors, fonts} from "ui/theme";
import {USDollar} from "utils";

export const PriceBreakdown = ({
                                   id,
                                   price: {
                                       booking_total_amount,
                                       discount_amount,
                                       teache_fee,
                                       tax,
                                       total_amount,
                                       refund_amount
                                   },
                                   size = 30,
                                   place = "top",

                               }) => {
    return (
        <>
            <TooltipWrapper
                data-tooltip-id={id}
                display="block"
                maxWidth='200px'
            >
                <ToolTipChildren size={size + "px"}>
                    <QuestionMarkIcon size={size}/>
                </ToolTipChildren>
                <ReactTooltip
                    id={id}
                    place={place}
                    effect="solid"
                    className="reactTooltip"
                    clickable={false}
                >
                    <TooltipContent>
                        {booking_total_amount ?
                            <div>
                                <span>Class cost</span>
                                <span>{USDollar.format(booking_total_amount)}</span>
                            </div>
                            : null}
                        {discount_amount ?
                            <div className="negative">
                                <span>Discount</span>
                                <span>{USDollar.format(discount_amount)}</span>
                            </div>
                            : null}

                        {teache_fee ?
                            <div className="negative">
                                <span>Service fee</span>
                                <span>{USDollar.format(teache_fee)}</span>
                            </div>
                            : null}

                        {tax ?
                            <div className="negative">
                                <span>Tax</span>
                                <span>{USDollar.format(tax)}</span>
                            </div>
                            : null}

                        {total_amount ?
                            <div className="total">
                                <span>Total cost</span>
                                <span>{USDollar.format(total_amount)}</span>
                            </div>
                            : null}

                        {refund_amount ?
                            <div className="total">
                                <span>Refund amount</span>
                                <span>{USDollar.format(refund_amount)}</span>
                            </div>
                            : null}
                    </TooltipContent>
                </ReactTooltip>
            </TooltipWrapper>
        </>
    );
};

export const TooltipWrapper = styled.div`
    position: relative;
    width: fit-content;
    display: ${({display}) => display};

    & .reactTooltip {
        z-index: 9;
        background-color: ${defaultThemeColors.white};
        color: ${defaultThemeColors.txt};
        max-width: ${({maxWidth}) => maxWidth};
        text-align: left;
        font-size: ${fonts.sizes.extraSmall};
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.2);
        opacity: 1;
        border-radius: 5px;
        padding: 10px 8px;
    }
`;

const TooltipContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    div {
        display: flex;
        justify-content: space-between;
        font-size: ${fonts.sizes.extraSmall};
        color: ${defaultThemeColors.txt};
        gap: 0.5rem;
    }

    .negative {
        color: ${defaultThemeColors.placeholder};
    }

    .total {
        font-weight: bold;
        color: ${defaultThemeColors.blue};
    }
`;

export const ToolTipChildren = styled.div`
    height: ${({size}) => size ?? "30px"};
    width: ${({size}) => size ?? "30px"};
    background-color: ${({backgroundColor}) =>
            backgroundColor ?? defaultThemeColors.lightBlue};
    color: ${({color}) => color ?? defaultThemeColors.blue};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${({border}) => border ?? "999px"};
    cursor: pointer;
`;
